<template>
 <main>
    <section class="bg-white dark:bg-staticsecondary-900 ">
      <div class="container flex items-center justify-center min-h-screen w-full px-6 py-12">
        <div>
          <base-logo :filename="logo" alt="EdasNEO" class="mb-6"/>
          <h1 class="mt-3 text-2xl font-semibold text-staticsecondary dark:text-white md:text-3xl">Error en la redirección</h1>
            <p class="mt-4 text-staticsecondary-600 dark:text-staticsecondary-400">Lo sentimos, ha ocurrido un error en el redireccionamiento.</p>
            <p class="mt-4 text-staticsecondary-600 dark:text-staticsecondary-400">Vuelva a intentarlo y si el problema persiste contacte con soporte@zerocoma.com.</p>
            <div class="flex items-center mt-6 gap-x-3">
              <router-link :to="{ name: 'login' }">
                  <base-button 
                mode="staticprimary"
                text="Página principal" 
                />
              </router-link>
            </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
export default {
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'edasneowhite.webp'
      }
      return 'edasneo.webp'
    },
  },
}
</script>
